










import { FlyoutDataI18n, FlyoutDataItem } from '@/lib/interfaces';
import { Component, Inject, Prop, Vue } from 'vue-property-decorator';

@Component({
  name: 'FlyoutGroupItem',
})
export default class FlyoutGroupItem extends Vue {
  @Prop({ required: true, type: Object }) itemData!: FlyoutDataItem;
  @Inject('i18n') private i18n!: FlyoutDataI18n;

  get itemName(): string {
    if (this.itemData.nameI18nKey && this.i18n.values[this.itemData.nameI18nKey])
      return this.i18n.values[this.itemData.nameI18nKey];
    else if (this.itemData.nameOverrideI18nKey && this.i18n.values[this.itemData.nameOverrideI18nKey])
      return this.i18n.values[this.itemData.nameOverrideI18nKey];
    else if (this.itemData.name) return this.itemData.name;
    else return 'Missing name';
  }
}
